import React from 'react';
// import { render } from "react-dom";
import church1 from './Images/church-1.jpg';
import church_2 from './Images/church-2.jpg';
import pastor from './Images/pastor.jpg';
import mens_ministry from './Images/mens_ministry.jpg';
import women_ministry from './Images/women_ministry.jpg';
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import "./slider-animations.css";
import "./styles.css";
//import Head from './Head';

const content = [
    {
      title: "Write something good here",
      description:
        "The others are some examples of some text that you can write and describe something or discuss an important issue over here",
      button: "Read More",
      image: `${church1}`,
      user: "Luan Gjokaj",
      userProfile: "https://i.imgur.com/JSW6mEk.png"
    },
    {
      title: "Write something good here",
      description:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Cras mattis consectetur purus sit amet fermentum. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Donec sed odio dui.",
      button: "Discover",
      image: `${church_2}`,
      user: "Erich Behrens",
      userProfile: "https://i.imgur.com/0Clfnu7.png"
    },
    {
      title: "Phasellus volutpat metus",
      description:
        "Write some sweet details here",
      button: "Buy now",
      image:`${pastor}`,
      user: "Bruno Vizovskyy",
      userProfile: "https://i.imgur.com/4KeKvtH.png"
    },
    {
      title: "Write something good here",
      description:
        "Nullam id dolor id nibh ultricies vehicula ut id elit. Cras mattis consectetur Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras mattis  purus sit amet fermentum. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Donec sed odio dui.",
      button: "Discover",
      image:`${mens_ministry}`,
      user: "Erich Behrens",
      userProfile: "https://i.imgur.com/0Clfnu7.png"
    },
    {
      title: "Write something good here",
      description:
        "quam venenatis vestibulum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentumconsectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Duis mollis, est non commodo luctus, nisi erat porttitor ligula.",
      button: "Buy now",
      image: `${women_ministry}`,
      user: "Bruno Vizovskyy",
      userProfile: "https://i.imgur.com/4KeKvtH.png"
    }
  ];

  

function ImageSlider({items}) {
    return (
        <div>
            
           
            <Slider className="slider-wrapper" autoplay={5000}>
                {content.map((item, index) => (
                    <div
                    key={index}
                    className="slider-content"
                    style={{ background: `url('${item.image}') no-repeat center center` }}
                    >
                    <div className="inner">
                        <h1>{item.title}</h1>
                        <p>{item.description}</p>
                        <button>{item.button}</button>
                    </div>
                    <section>
                        <img src={item.userProfile} alt={item.user} />
                        <span>
                        Posted by <strong>{item.user}</strong>
                        </span>
                    </section>
                    </div>
                ))}
            </Slider>
        </div>
    )
}

export default ImageSlider
